import { first } from 'rxjs/operators';
import { PropertyService, Property } from '@app/_components/yield-max/property';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PropertiesComponent } from '../property/property.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PropertyConfigComponent } from '../../property-config/property-config.component';
import { Locations } from '@app/_helpers/constants';

@Component({
    selector: 'app-properties-list',
    templateUrl: './property-list.component.html',
    styleUrls: ['./property-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PropertiesListComponent implements OnInit {
	isSearching = false;
	// properties: any[]=[];
	constructor(
		private propertyService: PropertyService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private activatedRoute: ActivatedRoute,
		private datePipe: DatePipe,
		private router: Router,
		private dialog: MatDialog,
		private constantService: ConstantService,
	) {
		this.statuses = propertyService.statuses;
		this.locations = this.constantService.locations;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() extSystemId: any;
	properties: any;
	property: Property;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	locations: any;

	//URL Filter
	filterCreateDay: any;
	filterUpdateDay: any;

	columns: any[] = [
		{ field: 'propertyId', header: 'Id', width: 'auto' },
		{ field: 'listingStatus', header: 'Status', width: 'auto' },
		{ field: 'locationId', header: 'Location', width: 'auto' },
		{ field: 'propertyCode', header: 'Code', width: 'auto' },
		{ field: 'adrUnit', header: 'Unit#', width: 'auto' },
		{ field: 'propertyName', header: 'Name', width: 'auto' },
		{ field: 'developmentName', header: 'Development Name', width: 'auto' },
		{ field: 'numBedrooms', header: 'Beds', width: 'auto' },
		{ field: 'numBathrooms', header: 'Baths', width: 'auto' },
		{ field: 'RateBucketVO.name', header: 'Rate Bucket', width: 'auto' },
		{ field: 'annualRevTargetAmnt', header: '$Rev Target', width: 'auto' },
		{ field: 'minNightlyRate', header: 'Min Nightly Rate', width: 'auto' },
		{ field: 'minLengthOfStay', header: 'Min Length of Stay', width: 'auto' },
		{ field: 'MgmtCommissionPct', header: 'Mgmt Commission', width: 'auto' },
		{ field: 'adrStreet', header: 'Address', width: 'auto' },
		{ field: 'vrboId', header: 'VRBO', width: 'auto' },
		{ field: 'extSystemId', header: 'ExtListingId', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.activatedRoute.queryParamMap.subscribe(params =>
			{
				this.filterCreateDay = params.get('createDate');
				this.filterUpdateDay = params.get('updateDate');;
			});
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'propertyCode', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.propertyId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-property-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if(this.extSystemId != null)
			{
				event.filters['extSystemId'] = {"value":this.extSystemId,"matchMode":"eq"};
			}
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'propertyCode', order: 1 });
			}

			if(this.filterCreateDay != null)
			{
				let filterCreateDay = this.addLocalTimeToDateTime(new Date(this.filterCreateDay));
				let date = this.datePipe.transform(filterCreateDay, 'yyyy-MM-ddThh:mm');
				event.filters['createDate'] = {"value":date,"matchMode":"in"};
			}

			if(this.filterUpdateDay != null)
			{
				let filterUpdateDay = this.addLocalTimeToDateTime(new Date(this.filterUpdateDay));
				let date = this.datePipe.transform(filterUpdateDay, 'yyyy-MM-ddThh:mm');
				event.filters['lastUpdate'] = {"value":date,"matchMode":"in"};
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findPropertyByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.properties = res.data.properties;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	// onRowSelect(event: any) {
	// 	console.log('onRowSelect: ' + JSON.stringify(event));
	// 	this.onOpenFormEdit(event.data);
	// }

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(property: Property) {
		try {
			this.formLoading = true;
			this.propertyService.update(property)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.properties.map((property, i) => {
							if (property.propertyId === res.data.property.propertyId) {
								this.properties[i] = res.data.property;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	get Locations() {
		return Locations;
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(property: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(property));

			this.formLoading = true;
			this.propertyService.delete(property.propertyId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.properties.splice(this.properties.indexOf(property), 1);
						this.recordTotal = this.properties.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Property ' + property.propertyId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Property ' + property.propertyId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Property'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertiesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(property: Property) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			property: property,
			title: 'Edit Property'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertiesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePropertyCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePropertyCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyCB(property: Property) {
		console.log('Adding Property: ' + JSON.stringify(property));
		// if we don't have a properties array yet...
		if (!this.properties) {
			this.properties = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.properties.unshift(property);

		// no idea what this is but it is required to update the array
		this.properties = [...this.properties];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Property ' + property.propertyId + ' Added', life: 3000 });
	}

	updatePropertyCB(property: Property) {
		console.log('Updating Property: ' + JSON.stringify(property));
		let itemIndex = this.properties.findIndex((item: any) => item.propertyId === property.propertyId);
		this.properties[itemIndex] = property;

		// no idea what this is but it is required to update the array
		this.properties = [...this.properties];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Property ' + property.propertyId + ' Updated', life: 3000 });
	}

	deletePropertyCB(property: Property) {
		console.log('Removing Property: ' + property);
		this.properties.splice(this.properties.indexOf(property), 1);
		this.recordTotal = this.properties.length;

		// no idea what this is but it is required to update the array
		this.properties = [...this.properties];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Property ' + property.propertyId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.properties ? this.first === (this.properties.length - this.rows) : true; }
	isFirstPage(): boolean { return this.properties ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(property: any) {
		
		if (property?.listingStatus != null) {
			const status = this.statuses.find((e: any) => e.value == property.listingStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	syncAllProperties() {
		try {
			this.propertyService.syncAllProperties()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync All Properties successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	eventConfirmation() {
		this.confirmationService.confirm({
			message: 'Are you sure? this process will take some time to complete, this process will run in background',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncAllProperties();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	onRowSelect(event) {
		try {
			// this.loading = true;
			// console.log('onRowSelect(' + JSON.stringify(event) + ')');
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			// this.router.navigate(['property-config/'+event.data.propertyId]);
			const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = true;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "90vw";
		dialogConfig.height = "45vw";
		dialogConfig.maxHeight = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyId: event.data.propertyId,
			rateBucketId: event.data.rateBucketId,
			propertyCode: event.data.propertyCode,
			title: 'Property Configuration'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyConfigComponent, dialogConfig);
		} catch (error) {
			console.log('onRowSelect(' + event + ')' + error);
		}
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
